/** Partner control - what ads can be shown where
 * 
 */
import React from 'react';

import { assert } from '../base/utils/assert';
import { yessy } from '../base/utils/miscutils';

import C from '../C';
import DataStore, { getPath } from '../base/plumbing/DataStore';
import ActionMan from '../plumbing/ActionMan';
import { getType } from '../base/data/DataClass';
import PropControl from '../base/components/PropControl';
import Misc from '../base/components/Misc';
import SavePublishDeleteEtc from '../base/components/SavePublishDeleteEtc';


function SMAPage() {
	// what are we looking at?
	const path = DataStore.getValue(['location','path']);
	const thingType = path[1];
	const thingId = path[2];
	if ( ! thingId) {
		return (<div>
			Please start with an Advertiser or Publisher.
		</div>);
	}
	assert(C.TYPES.has(thingType));

	const pvItem = ActionMan.getDataItem({type:thingType, id:thingId, status:C.KStatus.DRAFT});
	if ( ! pvItem.resolved) {
		return <Misc.Loading />;
	}
	let item = pvItem.value;

	// TODO fetch the sma list - keep it on the thing itself for fast access??
	const pcpath = getPath(C.KStatus.DRAFT, thingType, thingId).concat('partnerControl');
	let partnerControl = item.partnerControl;
	if ( ! partnerControl) partnerControl = item.partnerControl = {avoid: [], like: []};
	let avoid = partnerControl.avoid || [];
	let like = partnerControl.must || [];
	// ??compile rules into a trie?
	// but: kiss

	return (
		<div className="">
			<h2>Partner Control (black/white list) for {thingType} {thingId} {item.name}</h2>
			
			<p>
				TODO Entries can be IDs, or names, or categories.
				?? contains or equals??
			</p>

			<Misc.Col2>
				<div><h2>Must</h2>
					<RuleEditor value={like} path={pcpath.concat('must')} />
				</div>
				<div><h2>Must Not</h2>
					<RuleEditor value={avoid} path={pcpath.concat('avoid')} />
				</div>
			</Misc.Col2>

			TODO auto-complete for category and explicit brand

			<SavePublishDeleteEtc type={thingType} id={thingId} />

		</div>
	);
}


function RuleEditor({value, path}) {
	return <ListControl path={path} value={value} />;
}


const addBlank = ({path, list, base, make}) => {
	// Call the make?
	if (make) {
		base = make(base);
	}
	// if ( ! base) base = null; null is fine for a blank
	let alist = list.concat(base);
	DataStore.setValue(path, alist);
};


function ListControl({path, value, ItemEditor}) {
	const Ed = ItemEditor || PropControl;
	const list = value || [];
	return (<div className="ListControl">
		{list.map((x, i) => (
			<div key={i}>
				<Ed path={path} prop={i} />
				<button type="button" className="btn btn-sm btn-default"
					onClick={() => {
						let rlist = list.slice();
						rlist.splice(i, 1);
						DataStore.setValue(path, rlist);
					}}
				>
					<Misc.Icon fa="minus-circle" />
				</button>
			</div>
		))}
		<div>
			<button type="button" className="btn btn-default" onClick={() => addBlank({path, list})}><Misc.Icon fa="plus-circle" /></button>
		</div>
	</div>);
}


/**
 * A short summary of PC settings
 */
function PartnerControlSummary({item}) {
	const partnerControl = item.partnerControl || {};
	const type = getType(item);
	const id = item.id;
	return (<div>
		<p>This is for keeping notes (for now) - the Ad-Ops team then set this up in AppNexus.</p>
		<PartnerControlSummary2 title="Must" list={partnerControl.must} />
		<PartnerControlSummary2 title="Must Not" list={partnerControl.avoid} />
		{type && id? <a href={'#sma/'+type+'/'+id}>Edit the Block / Allow List</a> : null}
	</div>);
}


function PartnerControlSummary2({title, list}) {
	if ( ! yessy(list)) return null;
	return <div><i>{title}</i> {list.join(" or ")} </div>;
}


export default SMAPage;
export {PartnerControlSummary};
